import {
  Box,
  Card,
  CardContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useLoaderData } from "react-router";
import * as api from "../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "../components/Link";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";

export async function loader({ params, request }) {
  const res = await api.loadProduct(
    { id: params.id },
    api.contextFromRequest(request),
  );
  if (res.data.product == null) {
    throw new Response("Not Found", { status: 404, statusText: "Not Found" });
  }

  return res;
}

export default function Product() {
  const loaderData = useLoaderData();
  const product = loaderData.data.product;

  return (
    <>
      <Typography variant="h1" sx={{ mb: 2 }}>
        Produkt {product.name}
      </Typography>
      <Card>
        <CardContent>
          <TableContainer sx={{ maxHeight: "78vh" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Barva</TableCell>
                  <TableCell>Název služby</TableCell>
                  <TableCell>Typ</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {product.services.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <Box
                        sx={{
                          backgroundColor: row.color,
                          width: "1rem",
                          height: "1rem",
                        }}
                      ></Box>
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.type}</TableCell>
                    <TableCell>
                      <IconButton
                        component={Link}
                        to={`/products/services/${row.id}/edit`}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </>
  );
}
